// extracted by mini-css-extract-plugin
module.exports = {"headerBar":"u-z","pointsSection":"v-z","goToDashboard":"w-z"};